<div class="flexie-auto-grid p-t-20">
    <div>
        <!-- <h3 translate>Search Agent</h3> -->
        <app-ui-search [(SearchCriteria)]="CRITERIALOOKUP" (componentOutput)="fetchSearchResult($event)"
            searchURL="agentSearch" itemsPerPage='20'>
        </app-ui-search>
    </div>
    <div></div>
</div>
<div class="search-results m-t-20">
    <!-- Show Result Tables -->
    <div>
        <nz-table *ngIf="agentDataSet && agentDataSet.length > 0" #agentSearchTable [nzData]="agentDataSet"
            [nzSize]="'middle'" [nzShowPagination]="true">
            <thead>
                <tr>
                    <th></th>
                    <th>Intermediary No</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Channel</th>
                    <!-- <th>Contact Number</th>
                    <th>email ID</th> -->
                    <!-- <th>Select</th> -->
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let data of agentSearchTable.data">
                    <td><label nz-checkbox nzValue="data" [(ngModel)]="data['selected']"></label></td>
                    <td>{{data.agentNum}}</td>
                    <td>{{data.firstName}}</td>
                    <td>{{data.lastName}}</td>
                    <td>{{data.channelCd | technicalTranslate}}</td>
                    <!-- <td>{{data.contactNum}}</td>
                    <td>{{data.emailId}}</td> -->
                    <!-- <td>
                        <button nz-button nzType="dashed" *ngIf="selectedAgent?.agentNum == data.agentNum"
                            (click)="emitSelectedClient(data)">Selected</button>
                        <button nz-button nzType="primary" *ngIf="selectedAgent?.agentNum != data.agentNum"
                            (click)="emitSelectedClient(data)">Select</button>
                    </td> -->
                </tr>
            </tbody>


        </nz-table>
        <app-generic-zero-ui [list]="agentDataSet" icon="file-search" [title]="agentZeroState.title"
            [message]="agentZeroState.message" [icon]="agentZeroState.icon"></app-generic-zero-ui>
        <!-- Zero list -->
    </div>
</div>